/**
 * Navbar.js
 * Main navigation bar
 *
 * @class  Navbar
 * @author Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import IconButton from 'components/buttons/icon-button/IconButton'

export default React.createClass({

	propTypes: {
		fixed: React.PropTypes.bool,
		logo: React.PropTypes.oneOfType([
			React.PropTypes.component,
			React.PropTypes.string
		]),
		rightItems: React.PropTypes.oneOfType([
			React.PropTypes.component,
			React.PropTypes.string
		]),
		offsetTop: React.PropTypes.number
	},

	getDefaultProps() {
		return {
			fixed: true,
			logo: '',
			leftItems: '',
			rightItems: ''
		};
	},

	getInitialState() {
		return{
			leftIsCollapsed: false,
			rightIsCollapsed: false,
			collapsedContainerHeight: 0,
			collapsedContainerOpen: false
		};
	},

	componentDidMount() {
		window.addEventListener('resize', this._determineIfCollapsed);
		this._determineIfCollapsed();
		this._determineCollapsedContainerHeight();

	},

	componentDidUpdate(prevProps, prevState) {
		if (prevState.leftIsCollapsed !== this.state.leftIsCollapsed || prevState.rightIsCollapsed !== this.state.rightIsCollapsed) {
			this._determineCollapsedContainerHeight();
		}
	},

	componentWillUnmount(){
		window.removeEventListener('resize', this._determineIfCollapsed);
	},


	render() {

		let classes = ClassNames( 'lui-navbar', this.props.className, {
			'lui-fixed': this.props.fixed,
			'lui-is-collapsed': this.state.leftIsCollapsed || this.state.rightIsCollapsed
		});

		let styles = {
			top: this.props.offsetTop
		};

		if (this.props.style) {
			styles = Object.assign(styles, this.props.style);
		};

		let topSpacerStyles = { height: this.props.offsetTop },
			bottomSpacerStyles = { height: this.state.collapsedContainerHeight };

		let topSpacer = this.props.fixed ? (
			<div>
				<div style={topSpacerStyles} />
				<div className="lui-navbar" />
			</div>
		) : '';

		let bottomSpacer = this.props.fixed ? (
			<div style={bottomSpacerStyles} />
		) : '';

		let leftNavbarGroupClasses = ClassNames('lui-navbar-group','lui-left', {
			'lui-is-collapsed' : this.state.leftIsCollapsed
		});

		let rightNavbarGroupClasses = ClassNames('lui-navbar-group','lui-right', {
			'lui-is-collapsed' : this.state.rightIsCollapsed
		});

		let leftChildren, rightChildren;

		if (this.state.leftIsCollapsed) {
			leftChildren = this.props.children;
		};

		if (this.state.rightIsCollapsed) {
			rightChildren = this.props.rightItems;
		}

		return (
			<div>
				<div ref="navbar" className={classes} style={styles}>
					<div ref="logo" className="lui-navbar-logo lui-navbar-group">
						{this.props.logo}
					</div>
					<div ref="leftNavbarGroup" className={leftNavbarGroupClasses}>
						<ul className="lui-navbar-list">
							{this.props.children}
						</ul>
					</div>
					<div ref="rightNavbarGroup" className={rightNavbarGroupClasses}>
						{this.props.rightItems}
					</div>
					<IconButton
						className="lui-navbar-expand-collapsed-nav-button"
						icon="bars"
						onClick={this._toggleNavbarCollapsed}/>
				</div>
				{topSpacer}
				<div ref="collapsedNavbarContainer" className="lui-collapsed-navbar-container">
					<ul className="lui-navbar-list">
						{leftChildren}
						{rightChildren}
					</ul>
				</div>
				{bottomSpacer}
			</div>
		);
	},

	_determineIfCollapsed() {

		let navbar = React.findDOMNode(this.refs.navbar),
			leftNavbarGroup = React.findDOMNode(this.refs.leftNavbarGroup),
			rightNavbarGroup = React.findDOMNode(this.refs.rightNavbarGroup),
			logo = React.findDOMNode(this.refs.logo),
			navbarPaddingRight = getComputedStyle(navbar).paddingRight;

			navbarPaddingRight = parseInt(navbarPaddingRight.replace('px',''));

			let leftNavbarGroupWidth = leftNavbarGroup.offsetWidth + rightNavbarGroup.offsetWidth + logo.offsetWidth + navbarPaddingRight + 30;
			let rightNavbarGroupWidth = rightNavbarGroup.offsetWidth + logo.offsetWidth + navbarPaddingRight + 30;

		// Determine if left side is collapsed
		if ( !this.state.leftIsCollapsed && leftNavbarGroupWidth > navbar.offsetWidth) {
			this.setState ({
				leftIsCollapsed: true
			});
		} else if ( this.state.leftIsCollapsed && leftNavbarGroupWidth < navbar.offsetWidth ) {
			this.setState({
				leftIsCollapsed: false
			});
		}

		// Determine if right side is collapsed
		if (this.state.leftIsCollapsed) {
			if ( !this.state.rightIsCollapsed && rightNavbarGroupWidth > navbar.offsetWidth ) {
				this.setState ({
					rightIsCollapsed: true
				});
			} else if (this.state.rightIsCollapsed && rightNavbarGroupWidth < navbar.offsetWidth  ) {
				this.setState ({
					rightIsCollapsed: false
				});
			}
		}
	},

	_determineCollapsedContainerHeight() {
		let container = React.findDOMNode(this.refs.collapsedNavbarContainer);

		this.setState({
			collapsedContainerHeight: container.offsetHeight,
			collapsedContainerOpen: container.offsetHeight > 0 ? true : false
		});
	},

	_toggleNavbarCollapsed() {
		if (this.state.collapsedContainerOpen) {
			this._closeNavbarCollapsedContainer();
		} else {
			this._openNavbarCollapsedContainer();
		}

	},

	_openNavbarCollapsedContainer() {
		let element = React.findDOMNode(this.refs.collapsedNavbarContainer);

		let prevheight = element.style.height

		element.style.height = 'auto'

		let endheight = getComputedStyle(element).height

		element.style.height = prevheight
		element.offsetHeight // force repaint
		element.style.transition = 'height .1s'
		element.style.height = endheight

		let _this = this;
		element.addEventListener('transitionend', function transitionEnd(event) {
			if (event.propertyName == 'height') {
				element.style.transition = ''
				element.style.height = 'auto'
				_this._determineCollapsedContainerHeight();
				element.removeEventListener('transitionend', transitionEnd, false)
			}
		}, false)
	},

	_closeNavbarCollapsedContainer() {
		let element = React.findDOMNode(this.refs.collapsedNavbarContainer);

		element.style.height = getComputedStyle(element).height
		element.style.transition = 'height .1s'
		element.offsetHeight // force repaint
		element.style.height = '0px'

		let _this = this;

		element.addEventListener('transitionend', function transitionEnd(event) {
			if (event.propertyName == 'height') {
				_this._determineCollapsedContainerHeight();
				element.removeEventListener('transitionend', transitionEnd, false)
			}
		}, false);
	},

});



/** WEBPACK FOOTER **
 ** ./src/components/navbar/Navbar.js
 **/